import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { AlertTriangle, Home } from 'lucide-react';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const tipo = searchParams.get('tipo');
  const messaggio = searchParams.get('messaggio');

  const getMessaggioErrore = () => {
    switch (tipo) {
      case 'oauth':
        return {
          titolo: 'Errore di autenticazione',
          descrizione: messaggio || 'Si è verificato un errore durante l\'autenticazione con OAuth2.'
        };
      case 'csrf':
        return {
          titolo: 'Errore di sicurezza',
          descrizione: 'Token di sicurezza non valido. Riprova ad effettuare il login.'
        };
      case 'code_mancante':
        return {
          titolo: 'Codice di autorizzazione mancante',
          descrizione: 'Il codice di autorizzazione non è stato fornito. Riprova ad effettuare il login.'
        };
      case 'token_exchange':
        return {
          titolo: 'Errore durante lo scambio del token',
          descrizione: messaggio || 'Si è verificato un errore durante lo scambio del token di autorizzazione.'
        };
      default:
        return {
          titolo: 'Errore',
          descrizione: 'Si è verificato un errore imprevisto.'
        };
    }
  };

  const errore = getMessaggioErrore();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f0f0',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        background: 'white',
        borderRadius: '4px',
        boxShadow: 'var(--shadow-elevated)',
        padding: '40px',
        textAlign: 'center'
      }}>
        <AlertTriangle size={64} color="#d13438" style={{ marginBottom: '24px' }} />
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '16px'
        }}>
          {errore.titolo}
        </h1>
        
        <p style={{
          fontSize: '14px',
          color: 'var(--text-secondary)',
          marginBottom: '32px',
          lineHeight: '1.6'
        }}>
          {errore.descrizione}
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <a href="/auth/login" className="btn btn-primary">
            Riprova il login
          </a>
          <Link to="/" className="btn btn-secondary">
            <Home size={18} />
            Torna alla home
          </Link>
        </div>

        <div style={{
          marginTop: '32px',
          paddingTop: '32px',
          borderTop: '1px solid var(--border-color)'
        }}>
          <p className="text-small text-muted">
            Se il problema persiste, contatta l'assistenza
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

